var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockfill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7373 18.1182H11.2627C12.4404 18.1182 13.0205 17.5381 13.0205 16.2549V9.67188C13.0205 8.51172 12.5459 7.92285 11.5615 7.82617V5.65527C11.5615 2.31543 9.33789 0.707031 7 0.707031C4.66211 0.707031 2.43848 2.31543 2.43848 5.65527V7.85254C1.52441 7.99316 0.979492 8.57324 0.979492 9.67188V16.2549C0.979492 17.5381 1.55957 18.1182 2.7373 18.1182ZM4.12598 5.49707C4.12598 3.44922 5.42676 2.32422 7 2.32422C8.56445 2.32422 9.87402 3.44922 9.87402 5.49707V7.80859L4.12598 7.81738V5.49707Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockfill);
export default __webpack_public_path__ + "static/media/lock.fill.ffa1f1ac.svg";
export { ForwardRef as ReactComponent };